import { Typography } from '@mui/material'

import { PanelBox } from '../default'

/**
 * @description Renders the DashboardPanel component.
 *
 * @author Maria Eduarda Franke
 * @returns {React.Element} The rendered DashboardPanel component.
 */
const DashboardPanel = () => {

    return (
        <PanelBox>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Dashboard Manager - Limite de Crédito Dinâmico
            </Typography>
        </PanelBox>
    )
}

export default DashboardPanel